module.exports = __webpack_public_path__ + "img/8.aeb1aa6f.jpeg";